import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch } from 'vue'
import MoneyInput from '@/components/Inputs/MoneyInput.vue'

interface BundlePriceConfig {
  min_quantity: number
  affected_quantity: number
  bundle_price: number | null
  price_mode: 'cart_total' | 'line_item' | 'quantity'
  allow_reapplication: boolean
  error_message: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BundlePriceRule',
  props: {
  ruleConfig: { type: Object, required: true }
},
  emits: ["update"],
  setup(__props, { emit }: { emit: ({
  (e: 'update', config: BundlePriceConfig): void
}), expose: any, slots: any, attrs: any }) {

const props = __props





const modeOptions = [
  { value: 'cart_total', label: 'Group total' },
  { value: 'line_item', label: 'Per line' },
  { value: 'quantity', label: 'Per unit' }
]

const localConfig = ref<BundlePriceConfig>({
  min_quantity: 1,
  affected_quantity: 1,
  bundle_price: null,
  price_mode: 'cart_total',
  allow_reapplication: false,
  error_message: ''
})

const reapplyHint = computed(() =>
  localConfig.value.allow_reapplication
    ? 'The bundle repeats for every additional full group; leftover items stay at full price.'
    : 'The bundle applies once; remaining items stay at full price.'
)

const initialized = ref(false)
watch(
  () => props.ruleConfig,
  (newVal) => {
    if (newVal && !initialized.value) {
      localConfig.value = { ...localConfig.value, ...(newVal as Partial<BundlePriceConfig>) }
      initialized.value = true
    }
  },
  { immediate: true, deep: true }
)

function onQuantityChange(value: number, oldValue: number) {
  // The typical bundle is "buy N for $X" where N is both the trigger and the
  // priced group: track the qualifier in both directions while the two match,
  // and never let the priced count exceed the qualifier (the save guard
  // rejects that state, so do not create it here).
  if (localConfig.value.affected_quantity === oldValue) {
    localConfig.value.affected_quantity = localConfig.value.min_quantity
  } else if (localConfig.value.affected_quantity > localConfig.value.min_quantity) {
    localConfig.value.affected_quantity = localConfig.value.min_quantity
  }
  emitUpdate()
}

function onModeChange(mode: BundlePriceConfig['price_mode']) {
  localConfig.value.price_mode = mode
  emitUpdate()
}

function onPriceInput(value: number | null) {
  localConfig.value.bundle_price = value
  emitUpdate()
}

function emitUpdate() {
  emit('update', { ...localConfig.value })
}

return { __sfc: true,props, emit, modeOptions, localConfig, reapplyHint, initialized, onQuantityChange, onModeChange, onPriceInput, emitUpdate, MoneyInput }
}

})